import { FC } from 'react'
import styled from 'styled-components'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'

const TableComponent: FC<{
  tableTitle?: string
  tableColumnHeaders?: string[]
  parties?: string[]
  seatsToday: string[]
  seatsForecast: string[]
  seatsChange: string[]
  colorMode?: string
  tenant: Tenant
}> = ({
  tableTitle,
  tableColumnHeaders,
  parties,
  seatsToday,
  seatsForecast,
  seatsChange,
  colorMode,
  tenant,
}) => {
  return (
    <>
      {tableTitle && <Title>{tableTitle}</Title>}
      <Legend>
        <div className='wrapper'>
          <div className='box keep'></div>
          <div>{tenant?.lang === 'fr' ? 'Siège maintenu' : 'Sitz halten'}</div>
        </div>
        <div className='wrapper'>
          <div className='box win'>
            <span className='plus'>+</span>
          </div>
          <div>{tenant?.lang === 'fr' ? 'Siège gagné' : 'Sitzgewinn'}</div>
        </div>
        <div className='wrapper'>
          <div className='box lose'>
            <span className='minus'>–</span>
          </div>
          <div>{tenant?.lang === 'fr' ? 'Siège perdu' : 'Sitzverlust'}</div>
        </div>
      </Legend>
      <Table className='ui table very basic unstackable'>
        <thead>
          <tr>
            {tableColumnHeaders &&
              tableColumnHeaders.map(
                (itemColumnHeader: string, columnHeaderIndex: number) => {
                  return (
                    <th
                      dangerouslySetInnerHTML={{ __html: itemColumnHeader }}
                      key={columnHeaderIndex}
                      className={
                        colorMode === 'dark'
                          ? 'tableTitle bottom aligned dark' +
                            (tableColumnHeaders.length - 1 === columnHeaderIndex
                              ? ' lastColumn'
                              : '')
                          : 'tableTitle bottom aligned' +
                            (tableColumnHeaders.length - 1 === columnHeaderIndex
                              ? ' lastColumn'
                              : '')
                      }
                    ></th>
                  )
                }
              )}
          </tr>
        </thead>

        <tbody>
          {parties &&
            parties.map((itemParty: string, partyKey: number) => {
              const numberOfDivs =
                parseInt(seatsToday[partyKey], 10) >=
                parseInt(seatsForecast[partyKey], 10)
                  ? parseInt(seatsToday[partyKey], 10)
                  : parseInt(seatsForecast[partyKey], 10)
              const divArray = Array.from(
                { length: numberOfDivs },
                (v, k) => k + 1
              )
              return (
                <tr className='middle aligned' key={partyKey}>
                  <td className='middle aligned partei'>
                    <b>{itemParty}</b>
                  </td>
                  <td className='square'>
                    <div className='squareWrapper'>
                      {
                        // Create a div for each element in the array.
                        divArray.map((number, index) => {
                          let plus = false
                          let minus = false
                          if (index + 1 > parseInt(seatsToday[partyKey], 10)) {
                            plus = true
                          }
                          if (index >= parseInt(seatsForecast[partyKey], 10)) {
                            minus = true
                          }
                          return (
                            <div
                              key={number + index}
                              className={
                                (index < parseInt(seatsForecast[partyKey], 10)
                                  ? `square ${parties[partyKey]}`
                                  : `square ${parties[partyKey]} minus`) +
                                ' ' +
                                (index < parseInt(seatsToday[partyKey], 10)
                                  ? ''
                                  : `plus`)
                              }
                            >
                              {plus && <span className='plus'>+</span>}
                              {minus && <span className='minus'>–</span>}
                            </div>
                          )
                        })
                      }
                    </div>
                  </td>
                  {(seatsForecast || seatsChange) && (
                    <td className='right aligned trend'>
                      <b>{seatsForecast[partyKey]}</b> ({seatsChange[partyKey]})
                    </td>
                  )}
                </tr>
              )
            })}
        </tbody>
      </Table>
    </>
  )
}

const Title = styled.div`
  font-size: 2.3rem;
  font-family: var(--font-sans-serif);
  font-weight: 700;
  margin-bottom: 20px;
`
const Legend = styled.div`
  font-size: 1.6rem;
  line-height: 2.2rem;
  font-family: var(--font-sans-serif);
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0.5em;
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: baseline;
    margin-right: 1em;
    padding-bottom: 0.5rem;
    .box {
      margin-right: 0.5em;
      &.keep {
        width: 16px;
        height: 16px;
        background-color: var(--text-color);
        border: 1px solid var(--text-color);
      }
      &.win {
        width: 16px;
        height: 16px;
        background-color: var(--text-color);
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid var(--text-color);
      }
      &.lose {
        width: 16px;
        height: 16px;
        display: flex;
        border: 1px solid var(--text-color);
        border-style: dashed;
        align-items: center;
        justify-content: center;
      }
      span.plus,
      span.minus {
        line-height: 1em;
        margin: 0;
        padding: 0;
        @media only screen and (max-width: 599px) {
          font-size: 14px;
        }
      }
      span.plus {
        color: var(--site-background);
      }
      span.minus {
        color: var(--text-color);
      }
    }
  }
`

const Table = styled.table`
  color: var(--text-color) !important;
  width: 100%;
  margin: 0 0 3rem !important;
  th.tableTitle {
    font-size: 0.85em;
    font-weight: 400 !important;
    color: var(--text-color) !important;
    &.dark {
      border-bottom: 2px solid var(--gray-3);
    }
    &.lastColumn {
      text-align: right;
    }
  }
  td.middle.aligned.partei {
    padding-right: 0.5em;
  }
  td.square {
    width: 100%;
    min-width: 150px;
    @media only screen and (max-width: 599px) {
      padding-right: 0 !important;
    }
  }
  .squareWrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 2px;
  }

  div.square {
    box-sizing: border-box;
    /* margin: 0.1em; */
    width: calc(calc(100% / 20) - 2px);
    height: 20px;
    @media only screen and (max-width: 599px) {
      width: calc(calc(100% / 10) - 2px);
      height: 16px;
    }
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    opacity: 1;
    &.plus {
      /* border: 1px solid; */
      opacity: 1;
    }

    span.plus {
      font-size: 16px;
      margin: 0;
      padding: 0;
      color: #fff;
      @media only screen and (max-width: 599px) {
        font-size: 14px;
      }
    }
    span.minus {
      font-size: 16px;
      margin: 0;
      padding: 0;
      @media only screen and (max-width: 599px) {
        font-size: 14px;
      }
    }

    &.SVP,
    &.UDC {
      background-color: #4b8a3e;
    }
    &.FDP,
    &.PLR {
      background-color: #3872b5;
    }
    &.CVP,
    &.Mitte,
    &.Centre {
      background-color: #d6862b;
    }
    &.SP,
    &.PS {
      background-color: #f0554d;
    }
    &.GLP,&.PVL {
      background-color: #c4c43d;
    }
    &.GPS,
    &.Gruene,
    &.Grüne,
    &.Verts {
      background-color: #84b547;
    }
    &.EVP {
      background-color: #deaa28;
    }
    &.Lega {
      background-color: #9070d4;
    }
    &.Parteilos,
    &.parteilos,
    &.Diverse,
    &.Divers {
      background-color: #b8b8b8;
    }
    &.minus {
      background: transparent;
      font-weight: 600;
      opacity: 1;
      /* &.Parteilos,
      &.parteilos, &.Diverse {
        background-color: #b8b8b8;
        color: #b8b8b8;
      } */
      &.SP,
      &.PS {
        border: 1px dashed #f0554d;
        color: #f0554d;
      }
      &.SVP,
      &.UDC {
        border: 1px dashed #4b8a3e;
        color: #4b8a3e;
      }
      &.FDP,
      &.PLR {
        border: 1px dashed #3872b5;
        color: #3872b5;
      }
      &.GLP,&.PVL {
        border: 1px dashed #c4c43d;
        color: #c4c43d;
      }
      &.CVP,
      &.Mitte,
      &.Centre {
        border: 1px dashed #d6862b;
        color: #d6862b;
      }
      &.GPS,
      &.Gruene,
      &.Grüne,
      &.Verts {
        border: 1px dashed #84b547;
        color: #84b547;
      }
    }
  }
`

export default TableComponent
